import React from "react";
import styled from "styled-components";
import { company, intern } from "../../config";
import MeImg from "../../images/me.jpg";

const StyledAboutSection = styled.section`
  position: relative;
  background: var(--section);
  color: var(--white);
`;

const StyledAboutBody = styled.div`
  grid-template-columns: 100%;

  @media (min-width: 1024px) {
    grid-template-columns: 50% 50% !important;
  }
`;

const StyledAboutProfile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  .about-image-text {
    font-size: var(--smaller-font-size);
    font-family: var(--body-font-2);
    font-weight: var(--font-normal);
    margin-top: var(--mb-2);
    color: var(--gray-dark);
  }

  .about-image {
    border-radius: 100%;
    width: 250px;
    height: 250px;
    background: var(--white);
    color: var(--black-dark);
    object-fit: cover;
  }

  @media (min-width: 1024px) {
    .about-image {
      width: 300px;
      height: 300px;
    }
  }
`;

const StyledAboutContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: initial;

  h2 {
    margin-bottom: var(--mb-3);
    text-align: center;
  }

  p {
    font-size: var(--normal-font-size);
    font-family: var(--body-font-2);
    margin-bottom: var(--mb-2);
    line-height: 24px;
  }

  @media (min-width: 1024px) {
    h2 {
      text-align: initial;
    }

    p {
      max-width: 70%;
    }
  }
`;

const About = () => {
  return (
    <StyledAboutSection className="section" id="about-section">
      <span id="about" className="anchor"></span>
      <StyledAboutBody className="bd-grid">
        <StyledAboutProfile
          data-sal="slide-up"
          data-sal-delay="200"
          data-sal-easing="ease"
          data-sal-duration="1500"
        >
          <img className="about-image" alt="selfie" src={MeImg} />
          <p className="about-image-text">Selfie at Shanghai Disneyland</p>
        </StyledAboutProfile>
        <StyledAboutContent
          data-sal="slide-up"
          data-sal-delay="400"
          data-sal-easing="ease"
          data-sal-duration="1500"
        >
          <h2>About</h2>
          <p>
            Hello , I am Zi Jian and I enjoyed creating delightful , human
            centered digital experience. My main interest in UI /UX and build
            full-stack applications.
          </p>
          <p>
            I had a wonderful internship experience in{" "}
            <a className="highlighted-context" href={intern}>
              innovative business solution company
            </a>{" "}
            . Currently a front-end web developer in{" "}
            <a className="highlighted-context" href={company}>
              Dasher
            </a>
            , focused on building ERP System that streamline business processes
            and workflows.
          </p>
          <p>
            Other than programming , I also love playing video games , reading
            manga and spending hours watching travelling and delicious food
            videos.
          </p>
        </StyledAboutContent>
      </StyledAboutBody>
    </StyledAboutSection>
  );
};

export default About;
